import fundaNowClient from '@/client/fundaNowClient'

export default {
  postApplication(data) {
    return fundaNowClient.call({
      url: '/todaystore/application/',
      method: 'POST',
      data: data
    })
  },
}
